import React from 'react';
export function Footer() {
  return <footer className="bg-dark text-crema py-12 px-6 lg:px-12 mt-12" data-id="element-38">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 items-center md:items-start text-center md:text-left" data-id="element-39">
        <div className="space-y-4" data-id="element-40">
          <h3 className="text-2xl font-serif text-white" data-id="element-41">
            Tu espacio para sanar
          </h3>
          <p className="text-gray-400 text-sm max-w-xs mx-auto md:mx-0" data-id="element-42">
            Acompañamiento psicológico profesional, empático y confidencial para
            tu bienestar emocional.
          </p>
        </div>

        <div className="space-y-4" data-id="element-43">
          <h4 className="text-lg font-medium text-white" data-id="element-44">Contacto</h4>
          <ul className="text-gray-400 text-sm space-y-2" data-id="element-45">
            <li data-id="element-46">Atención presencial y online</li>
            <li data-id="element-47">Consultorio en Neuquén Capital</li>
            <li data-id="element-48">Lunes a Viernes de 9:00 a 19:00hs</li>
          </ul>
        </div>

        <div className="space-y-4 md:text-right" data-id="element-49">
          <h4 className="text-lg font-medium text-white" data-id="element-50">Reserva tu turno</h4>
          <p className="text-gray-400 text-sm mb-4" data-id="element-51">
            Escríbeme por WhatsApp para coordinar nuestra primera sesión.
          </p>
          <a href="https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno" target="_blank" rel="noopener noreferrer" className="inline-block border border-terracota text-terracota hover:bg-terracota hover:text-white px-6 py-2 rounded-full transition-colors duration-300 text-sm" data-id="element-52">
            Enviar Mensaje
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-gray-700 text-center text-gray-500 text-sm" data-id="element-53">
        <p data-id="element-54">
          &copy; {new Date().getFullYear()} Lic. María Alejandra Ruiz. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}